import { FilteringGuide } from "./filteringGuide";

export class EquipmentFiltration {
    locationTypeId: number;
    filterSet: FilteringGuide[] = [];
}
